<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{ navigationTitle }}</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <!-- 这里边是一个表单 -->
    <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
      <el-card class="box-card">
        <el-form-item label="讲者姓名" prop="name">
          <el-col :span="13">
            <el-input v-model="reference.name" placeholder="请输入讲者姓名"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="国籍">
          <el-col :span="8">
            <el-input v-model="reference.country" placeholder="请输入国籍"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="头衔" prop="title">
          <el-col :span="8">
            <el-input v-model="reference.title" placeholder="输入议题"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="照片" prop="photo">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-col :span="11">
            <el-input v-model="reference.email" placeholder="请输入邮箱"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="机构">
          <el-col :span="11">
            <el-input v-model="reference.mechanism" placeholder="请输入所在机构"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="擅长领域" prop="areas_of_expertise">
          <el-col :span="24">
            <el-input type="textarea" row="2" v-model="reference.areas_of_expertise" placeholder="请输入所在机构"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="协会">
          <el-col :span="11">
            <el-input v-model="reference.association" placeholder="请输入所在协会"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="协会任职">
          <el-col :span="11">
            <el-input v-model="reference.association_appointment" placeholder="请输入协会任职"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="协会LOGO">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="logoHandleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="logoUrl">
            <img v-if="logoUrl" :src="logoUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <el-form-item label="期刊名称">
          <el-col :span="24">
            <el-input v-model="reference.periodical" placeholder="请输入期刊名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊任职">
          <el-col :span="24">
            <el-input v-model="reference.journal_appointment" placeholder="请输入期刊任职"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊影响因子">
          <el-col :span="24">
            <el-input v-model="reference.influence_factor" placeholder="期刊影响因子"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊分区">
          <el-col :span="8">
            <el-select v-model="reference.periodical_division" placeholder="请选择分区">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊类别">
          <el-col :span="8">
            <el-select v-model="reference.journal_level" filterable allow-create default-first-option placeholder="请选择类别">
              <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="期刊封面">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="coverUrlHandleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="coverUrl">
            <img v-if="coverUrl" :src="coverUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="reference.remarks">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'editorProject',
  data() {
    return {
      navigationTitle: '录入外籍讲者',
      categoryList: [],
      options: [
        { name: '一区', id: 1 },
        { name: '二区', id: 2 },
        { name: '三区', id: 3 },
        { name: '四区', id: 4 },
      ],
      reference: {
        id: '', //主键id 有时修改 空时添加
        name: '',//姓名
        country: '',//国家
        photo: '',//照片
        title: '',//头衔 
        email: '',//邮箱
        mechanism: '',//机构
        areas_of_expertise: '',//擅长领域
        association: '',//协会 
        association_appointment: '',//协会任职 
        association_logo: '',//协会logo
        periodical: '',//期刊
        journal_appointment: '',//期刊任职  
        influence_factor: '',//影响因子 
        periodical_division: '',//期刊分区
        journal_level: '',//级别
        journal_cover: '',//期刊封面
        remarks: '',//备注
        project_id: '',//项目id，在编辑项目时录入专家时传递，信息库添加专家时不需要  
      },
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      logoUrl: "",
      coverUrl: "",
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入讲者名称', trigger: 'blur' },
        ],
        photo: [
          { required: true, message: '请选择照片', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入头衔', trigger: 'blur' },
        ],
        areas_of_expertise: [
          { required: true, message: '请输入擅长领域', trigger: 'blur' },
        ],
      },
      needLocateToErr: false,
    }
  },
  created() {
    //111111111111111111111111111111111111111
    // 录入外籍讲着：动态添加 三大模块  （一一对应） 
    //111111111111111111111111111111111111111
    this.getCategory()
    if (this.$route.query.id != "") this.getEditorDetails(this.$route.query.type, this.$route.query.id)
  },
  methods: {
    //点击编辑进来获取详情
    async getEditorDetails(type, id) {
      this.navigationTitle = '编辑外籍讲者'
      const { data: data } = await this.$http.post("info/detail", { type, id })
      this.reference = data.data
      // this.reference.journal_level = Number(this.reference.journal_level)
      // this.reference.periodical_division = Number(this.reference.journal_level) 
      this.imageUrl = data.data.photo
      this.logoUrl = data.data.association_logo
      this.coverUrl = data.data.journal_cover
    },
    //头像图片上传成功 
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.photo = res.data.url
    },
    //协会logo图片上传成功
    logoHandleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.logoUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.logoUrl = URL.createObjectURL(file.raw);
      this.reference.association_logo = res.data.url
    },
    //期刊封面
    coverUrlHandleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.coverUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.coverUrl = URL.createObjectURL(file.raw);
      this.reference.journal_cover = res.data.url
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitFormAPI()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交表单接口
    async submitFormAPI() {
      console.log(this.reference);
      const { data: data } = await this.$http.post("info/speaker", this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.push('/foreignerDatabase')
    },
    //返回上一层 
    backProject() {
      this.$router.back()
    },
    //获取期刊类别 
    async getCategory() {
      const { data: data } = await this.$http.post("cate/list", {
        type: '3'
      })
      this.categoryList = data.data
    }
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    margin-bottom: 40px;
  }

  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  // 上传文件
  .el-select {
    display: block;
  }
}
</style>
